const y = document.getElementById("y");
if (y) y.textContent = String(new Date().getUTCFullYear());

const reveals = document.querySelectorAll(".reveal");
const revObs = new IntersectionObserver(
  (entries) => {
    for (const e of entries) {
      if (e.isIntersecting) {
        e.target.classList.add("is-visible");
        revObs.unobserve(e.target);
      }
    }
  },
  { rootMargin: "0px 0px -8% 0px", threshold: 0.08 },
);
for (const el of reveals) revObs.observe(el);
